module.exports = __webpack_public_path__ + "media/images/online_talks/robot-317128967ee2d4ad2a68da16570864db.png";